<div class="header-bar fixed top-0 z-50 w-full h-[60px] pl-4 pr-1 sm:pl-[60px] sm:pr-[70px] flex items-center"
    [class.is-solid]="solid()">
    <a routerLink="/" class="cursor-pointer">
        <img src="/images/logo/semnexus.svg" alt="">
    </a>
    <div class="ml-auto flex items-center">
        <div (click)="scheduleCall()"
            class="relative inline-block w-[162px] h-[30px] rounded-[36px] cursor-pointer hover:scale-[1.04] hover:brightness-125 duration-300 transition">
            <img class="absolute inset-0" src="/images/button/border.svg" alt="" />
            <div
                class="relative w-full h-full text-[11px] flex items-center justify-center text-white font-outfit font-bold rounded-md">
                <img class="mr-[9px] h-[15px] relative -top-[3px]" src="/images/header/phone.svg" alt="" />
                <span class="text-[11px]">schedule a call</span>
            </div>
        </div>
        <img class="ml-1 sm:ml-[40px] cursor-pointer h-[20px] sm:h-[15px]" (click)="openMenu()" src="/images/header/burger-menu.svg" alt="">
    </div>
</div>